import LayoutSelector from 'layouts/LayoutSelector';
import React from 'react';
import { Route, Navigate, DataBrowserRouter } from 'react-router-dom';
import { routes } from './routes';
import { Routes as RoutesPath } from './routes.types';

const Router: React.FunctionComponent = () => {
    return (
        <DataBrowserRouter>
            <Route path="/" element={<LayoutSelector />}>
                {routes.map(({ name, path, element }) => (
                    <Route key={name} path={path} element={element} />
                ))}
                <Route path="*" element={<Navigate to={RoutesPath.NotFound} replace />} />
            </Route>
        </DataBrowserRouter>
    );
};

export default Router;
